import React/*, {useState}*/ from 'react';

import {useracc, postApi} from '../../utils/functions';
import {UserContext} from '../../utils/usercontext';
import EventEmitter from '../../utils/emmiter';

export default class AccountLogout extends React.Component {
  static contextType = UserContext;
  constructor(props) {
    super(props);
    this.state = {
			status: true,
			password: {
				text: '',
				valid: false,
				error: '',
				visible: false,
			},
			cookies: navigator.cookieEnabled
		};
  };

  async componentDidMount() {
		let params = new URLSearchParams();
		await postApi('/v3/account/logout', params);
		const value = this.context;
		const getUser = await useracc();
		value.setUser( getUser );
		window.location.href = '/';
		//EventEmitter.emit('/client', {data: 'no value'});
	}

	render() {
		return (
			<></>
		);
	}
}
